// Code review - In Progress
// Documentation - In Progress

import { useEffect, useState } from "react";
import { mappingroomtypewithSpaces, } from "../components/HeaderAttribute";
import GridPageWithCheckBox from "../components/GridPageWithCheckBox";
import Buttons from "../components/Buttons";
import { IUDAPI } from "../services/APIConnection";
import toast from "react-hot-toast";


const MappingRoomTypeWithSpacesPopp = ({ data1, spaceData, isOpen, data2 }) => {

    const [girdDatas, setGridDatas] = useState([]);
    const [checkBoxStatus, setCheckBoxStatus] = useState([]);
    const [selectedRows, setSelectedRows] = useState([]);
    const [submitBtnDisabled, setSubmitBtnDisabled] = useState(false);
    const createdBy = sessionStorage.getItem("createdBy");
    const mstClientId = sessionStorage.getItem("MstClientId");

    const [spaceDatas, setSpaceDatas] = useState([]);
    const [clearValues, setClearValues] = useState(false);

    const handleClearValues = (data) => {
        data && setClearValues(false);
    };
    const handle1 = (value) => {
        setSelectedRows(value);
        setCheckBoxStatus(value);
    };
    const handleSpaceData = (updatedData) => {
        setSpaceDatas(updatedData)
    };

    const handleSubmit = async (flag) => {
                
        console.log(selectedRows)
        if (selectedRows.length != 0) {
            if (spaceDatas.length != 0) {
                setSubmitBtnDisabled(true)
                const data = {
                    mstRoomTypeId: data1,
                    mstClientId:mstClientId,
                    mapDatas: JSON.stringify(spaceDatas),
                    createdBy: parseInt(createdBy),
                    flag: 1
                };

                const response = await IUDAPI(data, "MappingAPI/IUDMapRoomTypeAndSpace");
                const result = response.data.Table[0].Result;

                if (result === "S") {
                    toast.success("Successfully Mapped Room Type And Space. 👍", {
                        duration: 3000,
                        position: "top-center",
                    });
                    setTimeout(cancel, 3000);
                } else {
                    toast.error(
                        `Mapping Room Type And Space Failed 👎`,
                        {
                            duration: 3000,
                            position: "top-center",
                        }
                    );
                    setTimeout(cancel, 3000);
                }
            } else {
                toast.error(
                    `Please Fill The Data 👎`,
                    {
                        duration: 3000,
                        position: "top-center",
                    }
                );
            }
        } else {
            toast.error(
                `Please Select check Box And Fill Data 👎`,
                {
                    duration: 3000,
                    position: "top-center",
                }
            );
        }
    };

    const cancel = () => {

        setSubmitBtnDisabled(false)
        setSpaceDatas([])
        setClearValues(true);
        isOpen(false)
        setCheckBoxStatus([]);
        setSelectedRows([]);
    };


    useEffect(() => {

        if (data2.length != 0) {
            const updatedSpaceData = spaceData.map(space => {
                const match = data2.find(d => d.MstSpaceId === space.MstSpaceId);
                if (match) {
                    return {
                        ...space,
                        Date: match.Date,
                        SpaceCount: match.SpaceCount,
                    };
                }
                return space;
            });

            console.log(updatedSpaceData);
            setGridDatas(updatedSpaceData)
        } else {
            setGridDatas(spaceData)
        }
    }, [data2]);

    return (
        <div class="w-full p-2 overflow-y-auto" >
            <div class=" border-black  "></div>
            <GridPageWithCheckBox
                header={mappingroomtypewithSpaces}
                records={girdDatas}
                rowsPerPageView={true}
                blockView={true}
                addView={true}
                checkBoxVisible={true}
                checkBoxHeaderVisible={true}
                checkBoxStatus={handle1}
                isMultiSelect={true}
                selectedRows={selectedRows ?? []}
                tableHeight="h-72 overflow-y-auto"
                onSpaceDatas={handleSpaceData}
                onSpaceDataClear={clearValues}
                onSpaceDataClearFalse={handleClearValues}
            />
            <Buttons
                addScreenTitle={true}
                handleSubmit={handleSubmit}
                cancel={cancel}
                disabledBtn={submitBtnDisabled ? true : false}
            />
        </div>
    );
};

export default MappingRoomTypeWithSpacesPopp;
